interface PlaceholderProps {
  title: string;
}

export default function Placeholder({ title }: PlaceholderProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mb-4">
        <i className="ri-tools-line text-2xl text-primary-500"></i>
      </div>
      <h2 className="text-lg font-semibold text-foreground-800 font-heading mb-2">{title}</h2>
      <p className="text-sm text-foreground-500 max-w-md">
        Bu sayfa henüz hazırlanıyor. Kısa süre içinde tüm özellikleriyle kullanıma sunulacaktır.
      </p>
    </div>
  );
}